<template>
  <div class="sub-nav">
    <div class="line"></div>
    <div class="container">
      <div class="row">
        <component
          :is="item.enabled ? 'inertia-link' : 'span'"
          v-for="(item, index) in tabsToShow"
          :key="index"
          class="col"
          :class="{active: active === item.name, completed: completed(item.name)}"
          :href="asset ? `${route(`asset.${item.route}`, [assetType.slug, asset.id])}` : ''"
        >
          <span class="nav-item" :class="{ disabled: !item.enabled }">
            <i v-if="completed(item.name)" class="fal fa-check"></i>
          </span>
          <span class="label" :class="{ disabled: !item.enabled }">
            <small>{{ item.label }}</small>
          </span>
          <div v-if="active === item.name" class="arrow-up"></div>
        </component>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tabs: Array,
    assetType: Object,
    asset: Object,
    active: String,
  },

  computed: {
    tabsToShow() {
      return this.tabs.filter((t) => t.visible);
    },

    currentIndex() {
      return this.tabs.findIndex((tab) => tab.name === this.active);
    },
  },

  methods: {
    completed(name) {
      const index = this.tabsToShow.findIndex((tab) => tab.name === name);
      return index < this.currentIndex;
    },
  },
};
</script>
